import classNames from "classnames";
import { inject } from "mobx-react";
import React from "react";
import { intl } from "@fidget/common/i18n/TypedIntl";
import { IUiStore } from "../../models/ui/UiStore";
import { DiscardApplyButtons } from "./discardApplyButtons";
import styles from "./settingsForm.css";

interface Props {
  onDiscard?: () => any;
  onSubmit?: () => any;
  disabled: boolean;
  description?: string;
  uiStore?: IUiStore;
  withoutSaveDiscardButtons?: boolean;
  saveSectionClassName?: string;
  displayInline?: boolean;
}

@inject("uiStore")
export class SettingsForm extends React.Component<Props, {}> {
  componentDidMount() {
    document
      .getElementById("dashboard-container")!
      .addEventListener("click", this.preventAbandoningChanges, true);
  }

  componentWillUnmount() {
    document
      .getElementById("dashboard-container")!
      .removeEventListener("click", this.preventAbandoningChanges, true);
  }

  preventAbandoningChanges = (ev: MouseEvent) => {
    const { uiStore, disabled } = this.props;
    const target = ev.target as Node;
    if (!disabled && target.nodeName.toLowerCase() === "a") {
      ev.preventDefault();
      if (uiStore) {
        uiStore.addErrorToast(intl.formatMessage("settings.widgetConfig.unsavedChanges"));
      }
    }
  };

  render() {
    const {
      onDiscard,
      onSubmit,
      withoutSaveDiscardButtons,
      children,
      description,
      saveSectionClassName,
      displayInline
    } = this.props;

    if (onDiscard && onSubmit) {
      return (
        <form onSubmit={(ev) => ev.preventDefault()} className={classNames({ [styles.inline]: displayInline })}>
          {children}
          <section
            className={classNames(saveSectionClassName, {
              [styles["save-section"]]: !displayInline
            })}
          >
            <DiscardApplyButtons
              onDiscard={onDiscard}
              onApply={onSubmit}
              allDisabled={this.props.disabled}
              alignToLeft={!displayInline}
              hidden={withoutSaveDiscardButtons}
            />
            {!!description && <div className={styles.text}>{description}</div>}
          </section>
        </form>
      );
    }

    return children;
  }
}
